// Module
var code = "<!-- ko if: component() -->\r\n<div id=\"tooltip\" class=\"tooltip bubble\" data-bind=\"css: getPosition(), visible: visible\">\r\n    <div class=\"tooltip-inner\" data-bind=\"component: { name: component(), params: params() }\"></div>\r\n</div>\r\n<!-- /ko -->";
// Exports
module.exports = code;